module.exports = __webpack_public_path__ + "e08b25745aebb81e0227e2acab4209a7.svg";